<template>
  <div class="page-container" :class="{ dark: isDarkMode }">
    <ModalLoading :isLoading="cargando" />
    <div class="page-header">
      <div>
      </div>
      <div class="header-btns">
        <button v-if="puedeGenerarNomina"   class="btn-secondary" @click="abrirGenerar"><i class="bi bi-lightning-fill"></i> Generar Planilla del Mes</button>
        <button v-if="puedeRegistrarNomina" class="btn-primary"   @click="abrirNuevo"><i class="bi bi-plus"></i> Registrar Pago</button>
      </div>
    </div>

    <!-- Filtros -->
    <div class="filters-row">
      <div class="filter-group">
        <label>Mes</label>
        <input v-model="filtros.mes" type="month" class="form-input" @change="cargar" />
      </div>
      <div class="filter-group">
        <label>Empleado</label>
        <select v-model="filtros.id_empleado" class="form-select" @change="cargar">
          <option value="">Todos</option>
          <option v-for="e in empleados" :key="e.id_usuario" :value="e.id_usuario">
            {{ e.nombre }} {{ e.apellido }}
          </option>
        </select>
      </div>
      <div class="filter-group">
        <label>Estado</label>
        <select v-model="filtros.estado" class="form-select" @change="cargar">
          <option value="">Todos</option>
          <option>Pendiente</option>
          <option>Pagado</option>
        </select>
      </div>
      <div v-if="esCeo" class="filter-group">
        <label>Sucursal</label>
        <select class="form-select" v-model="filtroSucursal" @change="cargar">
          <option value="">Todas las sucursales</option>
          <option v-for="s in sucursalesCeo" :key="s.id_sucursal" :value="s.id_sucursal">
            {{ s.nombre_administrativo }}
          </option>
        </select>
      </div>
      <div class="filter-group totales-box" v-if="pagos.length">
        <span>Total filtrado:</span>
        <strong>L. {{ fmtNum(totalFiltrado) }}</strong>
      </div>
    </div>

    <!-- Tabla -->
    <div v-if="!pagos.length" class="empty-state">
      <i class="bi bi-cash-stack"></i>
      <p>No hay pagos registrados en este período.</p>
    </div>
    <div v-else class="table-container">
      <table class="data-table">
        <thead>
          <tr>
            <th>Empleado</th>
            <th>Concepto</th>
            <th>Período</th>
            <th>Monto</th>
            <th>Método</th>
            <th>Fecha Pago</th>
            <th>Estado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="p in paginatedPagos" :key="p.id_planilla">
            <td>{{ p.Usuarios?.nombre }} {{ p.Usuarios?.apellido }}</td>
            <td>{{ p.concepto }}</td>
            <td class="td-periodo">{{ parsePeriodo(p.notas) }}</td>
            <td><strong>L. {{ fmtNum(p.monto) }}</strong></td>
            <td>
              <span class="badge-metodo" :class="metodoCls(p.metodo_pago)">
                <i :class="metodoCls(p.metodo_pago) === 'metodo-efectivo' ? 'bi bi-cash' : p.metodo_pago === 'Cheque' ? 'bi bi-file-text' : 'bi bi-bank'"></i>
                {{ p.metodo_pago }}
              </span>
            </td>
            <td>{{ fmtFecha(p.fecha_pago) }}</td>
            <td>
              <span :class="p.estado === 'Pagado' ? 'badge-success' : 'badge-warning'">{{ p.estado }}</span>
            </td>
            <td class="actions">
              <button v-if="p.estado !== 'Pagado' && puedeRegistrarNomina" class="btn-icon success" @click="confirmarPago(p)" title="Marcar pagado">
                <i class="bi bi-check-lg"></i>
              </button>
              <button v-if="p.notas" class="btn-icon info" @click="verNota(p)" title="Ver nota">
                <i class="bi bi-chat-text"></i>
              </button>
              <button v-if="p.estado !== 'Pagado' && puedeEliminarNomina" class="btn-icon danger" @click="confirmarEliminar(p)" title="Eliminar">
                <i class="bi bi-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Paginación -->
      <div class="pagination-wrapper">
        <div class="pagination-info">
          Mostrando {{ (currentPage - 1) * pageSize + 1 }} a
          {{ Math.min(currentPage * pageSize, pagos.length) }}
          de {{ pagos.length }} registros
        </div>
        <div class="pagination-container">
          <button class="pagination-button" :disabled="currentPage === 1" @click="previousPage">
            Anterior
          </button>
          <button class="pagination-button" :disabled="currentPage === totalPages" @click="nextPage">
            Siguiente
          </button>
        </div>
      </div>
    </div>

    <!-- ─── Modal: Generar Planilla ─── -->
    <div v-if="modalGenerar" class="modal-overlay">
      <div class="modal-box modal-xl">
        <div class="modal-header">
          <h2><i class="bi bi-lightning-fill"></i> Generar Planilla
            <span class="badge-frecuencia badge-frecuencia-{{ genForm.frecuencia.toLowerCase() }}">{{ genForm.frecuencia }}</span>
          </h2>
          <button class="btn-close-x" @click="modalGenerar = false"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="modal-body">

          <div class="gen-config">
            <div class="form-group">
              <label>Mes a generar <span class="req">*</span></label>
              <input v-model="genForm.mes" type="month" class="form-input" />
            </div>
            <div class="form-group">
              <label>Frecuencia <span class="req">*</span></label>
              <select v-model="genForm.frecuencia" class="form-select">
                <option>Mensual</option>
                <option>Quincenal</option>
                <option>Semanal</option>
              </select>
            </div>
            <div class="form-group" v-if="genForm.frecuencia !== 'Mensual'">
              <label>Período <span class="req">*</span></label>
              <select v-model="genForm.periodo_label" class="form-select">
                <option v-for="p in periodosDisponibles" :key="p">{{ p }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>Fecha de pago <span class="req">*</span></label>
              <input v-model="genForm.fecha_pago" type="date" class="form-input" />
            </div>
            <div class="form-group">
              <label>Método de pago</label>
              <select v-model="genForm.metodo_pago" class="form-select">
                <option>Transferencia</option>
                <option>Efectivo</option>
                <option>Cheque</option>
              </select>
            </div>
          </div>

          <div class="frecuencia-info" v-if="genForm.frecuencia !== 'Mensual'">
            <i class="bi bi-info-circle"></i>
            Los montos se calculan automáticamente como <strong>salario base {{ genForm.frecuencia === 'Quincenal' ? '÷ 2' : '÷ 4' }}</strong>.
            Puedes editarlos manualmente antes de generar.
          </div>

          <div v-if="cargandoEmpleados" class="loading-sm"><div class="spinner-sm"></div> Cargando empleados...</div>

          <div v-else>
            <div class="gen-header-row">
              <span class="gen-label">Empleados ({{ empleadosIncluidos }}/{{ genEmpleados.length }})</span>
              <span class="gen-total">Total: <strong>L. {{ fmtNum(totalGenerar) }}</strong></span>
            </div>

            <div v-if="!genEmpleados.length" class="empty-state" style="padding:1.5rem">
              <i class="bi bi-people"></i>
              <p>No hay empleados activos en la empresa.</p>
            </div>

            <table v-else class="data-table gen-table">
              <thead>
                <tr>
                  <th style="width:36px">
                    <input type="checkbox" :checked="todosIncluidos" @change="toggleTodos" />
                  </th>
                  <th>Empleado</th>
                  <th>Salario (L.)</th>
                  <th style="width:80px; text-align:center">Incluir</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="e in genEmpleados" :key="e.id_usuario" :class="{ 'row-excluido': !e.incluir }">
                  <td>
                    <input type="checkbox" v-model="e.incluir" />
                  </td>
                  <td>
                    <span class="emp-nombre">{{ e.nombre }} {{ e.apellido }}</span>
                    <span v-if="!e.monto || e.monto <= 0" class="sin-salario">Sin salario base</span>
                  </td>
                  <td>
                    <input
                      v-model.number="e.monto"
                      type="number" min="0" step="0.01"
                      class="input-salario"
                      :class="{ 'input-warn': !e.monto || e.monto <= 0 }"
                      placeholder="0.00"
                    />
                  </td>
                  <td style="text-align:center">
                    <span v-if="e.incluir" class="badge-success" style="font-size:0.7rem">Sí</span>
                    <span v-else class="badge-danger"  style="font-size:0.7rem">No</span>
                  </td>
                </tr>
              </tbody>
            </table>

            <p class="gen-nota">
              <i class="bi bi-info-circle"></i>
              Los montos ingresados se guardarán como salario base de cada empleado para el próximo mes.
            </p>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-cancel" @click="modalGenerar = false">Cancelar</button>
          <button class="btn-success" @click="ejecutarGenerar"
            :disabled="generando || !genForm.mes || !genForm.fecha_pago || !empleadosIncluidos">
            <i class="bi bi-lightning-fill"></i>
            {{ generando ? 'Generando...' : `Generar ${genForm.frecuencia === 'Mensual' ? '' : genForm.periodo_label + ' — '}${empleadosIncluidos} salario${empleadosIncluidos !== 1 ? 's' : ''}` }}
          </button>
        </div>
      </div>
    </div>

    <!-- ─── Modal: Registrar Pago Manual ─── -->
    <div v-if="modalNuevo" class="modal-overlay">
      <div class="modal-box">
        <div class="modal-header">
          <h2><i class="bi bi-plus-circle"></i> Registrar Pago</h2>
          <button class="btn-close-x" @click="modalNuevo = false"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>Empleado <span class="req">*</span></label>
            <select v-model="form.id_empleado" class="form-select">
              <option :value="null" disabled>-- Seleccionar empleado --</option>
              <option v-for="e in empleados" :key="e.id_usuario" :value="e.id_usuario">
                {{ e.nombre }} {{ e.apellido }}
              </option>
            </select>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>Concepto <span class="req">*</span></label>
              <select v-model="form.concepto" class="form-select">
                <option>Salario</option>
                <option>Bono 14</option>
                <option>Aguinaldo</option>
                <option>Vacaciones</option>
                <option>Horas Extra</option>
                <option>Comisión</option>
                <option>Otro</option>
              </select>
            </div>
            <div class="form-group">
              <label>Monto (L.) <span class="req">*</span></label>
              <input v-model.number="form.monto" type="number" min="0.01" step="0.01" class="form-input" placeholder="0.00" />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>Método de Pago</label>
              <select v-model="form.metodo_pago" class="form-select">
                <option>Efectivo</option>
                <option>Transferencia</option>
                <option>Cheque</option>
              </select>
            </div>
            <div class="form-group">
              <label>Fecha de Pago <span class="req">*</span></label>
              <input v-model="form.fecha_pago" type="date" class="form-input" />
            </div>
          </div>
          <div class="form-group">
            <label>Notas</label>
            <textarea v-model="form.notas" class="form-textarea" rows="2" placeholder="Opcional..."></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-cancel" @click="modalNuevo = false">Cancelar</button>
          <button class="btn-confirmar" @click="guardar"
            :disabled="guardando || !form.id_empleado || !form.monto || !form.fecha_pago">
            {{ guardando ? 'Guardando...' : 'Registrar Pago' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Modal nota -->
    <div v-if="modalNota" class="modal-overlay">
      <div class="modal-box modal-sm">
        <div class="modal-header">
          <h2>Nota</h2>
          <button class="btn-close-x" @click="modalNota = false"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="modal-body">
          <p class="nota-text">{{ notaActiva }}</p>
        </div>
      </div>
    </div>

    <ConfirmModal
      :visible="confirmModal.visible"
      :titulo="confirmModal.titulo"
      :mensaje="confirmModal.mensaje"
      :tipo="confirmModal.tipo"
      @confirm="ejecutarConfirm"
      @cancel="confirmModal.visible = false"
    />
  </div>
</template>

<script>
import {
  getPlanilla, getPlanillaPorSucursal, getEmpleadosPlanilla,
  crearPagoPlanilla, marcarPagadoPlanilla, eliminarPagoPlanilla,
  generarPlanillaMensual
} from '../../services/featuresSolicitudes.js';
import { getSucursalesbyEmmpresaSumm } from '../../services/sucursalesSolicitudes.js';
import { hasAccionPermiso } from '../../services/permisos.js';
import { useToast } from 'vue-toastification';
import ConfirmModal from '../components/ConfirmModal.vue';
import ModalLoading from "@/components/ModalLoading.vue";
import { setPageTitle } from '@/components/pageMetadata';
const { getSocket } = require('@/services/socket');

export default {
  name: 'NominaPage',
  components: { ConfirmModal, ModalLoading },
  data() {
    const token = localStorage.getItem('auth');
    const hoy   = new Date();
    const mesActual = `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}`;
    const ultimoDia = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0).toISOString().split('T')[0];
    return {
      toast: useToast(),
      isDarkMode: localStorage.getItem('isDarkMode') === 'true',
      id_usuario: token ? JSON.parse(atob(token.split('.')[1])).id_usuario : null,
      esCeo: Number(localStorage.getItem('role') || 0) === 4,
      sucursalesCeo: [],
      filtroSucursal: '',
      pagos: [], empleados: [], cargando: false, guardando: false,
      currentPage: 1, pageSize: 10,
      filtros: { mes: mesActual, id_empleado: '', estado: '' },
      modalNuevo: false, modalNota: false, notaActiva: '',
      confirmModal: { visible: false, titulo: '', mensaje: '', tipo: 'danger', accion: null },
      form: { id_empleado: null, concepto: 'Salario', monto: '', metodo_pago: 'Efectivo', fecha_pago: hoy.toISOString().split('T')[0], notas: '' },
      // Generar planilla
      modalGenerar: false, generando: false, cargandoEmpleados: false,
      genEmpleados: [],
      genForm: { mes: mesActual, fecha_pago: ultimoDia, metodo_pago: 'Transferencia', frecuencia: 'Mensual', periodo_label: 'Mes Completo' },
    };
  },
  computed: {
    puedeGenerarNomina()    { return hasAccionPermiso('nomina_generar'); },
    puedeRegistrarNomina()  { return hasAccionPermiso('nomina_pagar'); },
    puedeEliminarNomina()   { return hasAccionPermiso('nomina_eliminar'); },
    paginatedPagos() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.pagos.slice(start, start + this.pageSize);
    },
    totalPages() {
      return Math.ceil(this.pagos.length / this.pageSize);
    },
    totalFiltrado() {
      return this.pagos.reduce((s, p) => s + Number(p.monto || 0), 0);
    },
    empleadosIncluidos() {
      return this.genEmpleados.filter(e => e.incluir).length;
    },
    todosIncluidos() {
      return this.genEmpleados.length > 0 && this.genEmpleados.every(e => e.incluir);
    },
    totalGenerar() {
      return this.genEmpleados
        .filter(e => e.incluir)
        .reduce((s, e) => s + Number(e.monto || 0), 0);
    },
    periodosDisponibles() {
      if (this.genForm.frecuencia === 'Quincenal') return ['1ra Quincena', '2da Quincena'];
      if (this.genForm.frecuencia === 'Semanal')   return ['Semana 1', 'Semana 2', 'Semana 3', 'Semana 4'];
      return ['Mes Completo'];
    },
    divisorFrecuencia() {
      if (this.genForm.frecuencia === 'Quincenal') return 2;
      if (this.genForm.frecuencia === 'Semanal')   return 4;
      return 1;
    },
  },
  watch: {
    'genForm.frecuencia'(nuevo) {
      const defaults = { Mensual: 'Mes Completo', Quincenal: '1ra Quincena', Semanal: 'Semana 1' };
      this.genForm.periodo_label = defaults[nuevo] || 'Mes Completo';
      const div = { Mensual: 1, Quincenal: 2, Semanal: 4 }[nuevo] || 1;
      this.genEmpleados.forEach(e => { e.monto = +(Number(e.salario_base || 0) / div).toFixed(2); });
    },
  },
  async mounted() {
    setPageTitle('Nómina');
    this._darkListener = () => { this.isDarkMode = localStorage.getItem('isDarkMode') === 'true'; };
    window.addEventListener('poswave:toggle-dark', this._darkListener);
    if (this.esCeo) {
      this.sucursalesCeo = await getSucursalesbyEmmpresaSumm(this.id_usuario);
      if (!Array.isArray(this.sucursalesCeo)) this.sucursalesCeo = [];
    }
    await Promise.all([this.cargar(), this.cargarEmpleados()]);
    const _s = getSocket();
    if (_s) { this._wsRefresh = () => this.cargar(); _s.on('nomina:refresh', this._wsRefresh); }
  },
  beforeUnmount() {
    window.removeEventListener('poswave:toggle-dark', this._darkListener);
    const _s = getSocket();
    if (_s && this._wsRefresh) _s.off('nomina:refresh', this._wsRefresh);
  },
  methods: {
    mostrarConfirm(titulo, mensaje, accion, tipo = 'danger') {
      this.confirmModal = { visible: true, titulo, mensaje, tipo, accion };
    },
    ejecutarConfirm() {
      this.confirmModal.visible = false;
      if (this.confirmModal.accion) this.confirmModal.accion();
    },
    previousPage() { if (this.currentPage > 1) this.currentPage--; },
    nextPage()     { if (this.currentPage < this.totalPages) this.currentPage++; },
    async cargar() {
      this.currentPage = 1;
      this.cargando = true;
      try {
        const params = {};
        if (this.filtros.mes)         params.mes         = this.filtros.mes;
        if (this.filtros.id_empleado) params.id_empleado = this.filtros.id_empleado;
        if (this.filtros.estado)      params.estado      = this.filtros.estado;
        if (this.filtroSucursal) {
          this.pagos = await getPlanillaPorSucursal(this.id_usuario, this.filtroSucursal, params);
        } else {
          this.pagos = await getPlanilla(this.id_usuario, params);
        }
      } catch (e) { this.toast.error('Error al cargar: ' + e.message); }
      finally { this.cargando = false; }
    },
    async cargarEmpleados() {
      try { this.empleados = await getEmpleadosPlanilla(this.id_usuario); }
      catch (e) { console.error(e); }
    },

    // ── Generar planilla ──
    async abrirGenerar() {
      const hoy = new Date();
      const mes = `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}`;
      const ultimoDia = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0).toISOString().split('T')[0];
      this.genForm = { mes, fecha_pago: ultimoDia, metodo_pago: 'Transferencia', frecuencia: 'Mensual', periodo_label: 'Mes Completo' };
      this.modalGenerar = true;
      this.cargandoEmpleados = true;
      try {
        const lista = await getEmpleadosPlanilla(this.id_usuario);
        this.genEmpleados = lista.map(e => ({
          ...e,
          salario_base: Number(e.salario_base || 0),
          monto:        Number(e.salario_base || 0),
          incluir:      true,
        }));
      } catch (e) {
        this.toast.error('Error al cargar empleados: ' + e.message);
        this.genEmpleados = [];
      } finally { this.cargandoEmpleados = false; }
    },
    toggleTodos(ev) {
      this.genEmpleados.forEach(e => { e.incluir = ev.target.checked; });
    },
    async ejecutarGenerar() {
      const incluidos = this.genEmpleados.filter(e => e.incluir);
      if (!incluidos.length) { this.toast.warning('Selecciona al menos un empleado.'); return; }

      const sinMonto = incluidos.filter(e => !e.monto || e.monto <= 0);
      if (sinMonto.length) {
        this.toast.warning(`${sinMonto.length} empleado(s) sin monto. Ingresa un salario para continuar.`);
        return;
      }

      this.generando = true;
      try {
        const res = await generarPlanillaMensual(this.id_usuario, {
          mes:           this.genForm.mes,
          fecha_pago:    this.genForm.fecha_pago,
          metodo_pago:   this.genForm.metodo_pago,
          frecuencia:    this.genForm.frecuencia,
          periodo_label: this.genForm.periodo_label,
          empleados:     incluidos.map(e => ({ id_empleado: e.id_usuario, monto: e.monto })),
        });
        this.toast.success(`Planilla generada: ${res.creados} salario${res.creados !== 1 ? 's' : ''} creados.`);
        this.modalGenerar = false;
        this.filtros.mes = this.genForm.mes;
        await Promise.all([this.cargar(), this.cargarEmpleados()]);
      } catch (e) {
        this.toast.error(e.message || 'Error al generar planilla.');
      } finally { this.generando = false; }
    },

    // ── Registro manual ──
    abrirNuevo() { this.modalNuevo = true; },
    async guardar() {
      if (!this.form.id_empleado || !this.form.monto || !this.form.fecha_pago) {
        this.toast.warning('Empleado, monto y fecha son requeridos.');
        return;
      }
      this.guardando = true;
      try {
        await crearPagoPlanilla(this.id_usuario, this.form);
        this.toast.success('Pago registrado.');
        this.modalNuevo = false;
        this.form = { id_empleado: null, concepto: 'Salario', monto: '', metodo_pago: 'Efectivo', fecha_pago: new Date().toISOString().split('T')[0], notas: '' };
        await this.cargar();
      } catch (e) { this.toast.error('Error: ' + e.message); }
      finally { this.guardando = false; }
    },
    async confirmarPago(p) {
      this.mostrarConfirm(
        'Confirmar pago',
        `¿Marcar como Pagado a ${p.Usuarios?.nombre} ${p.Usuarios?.apellido} por L. ${this.fmtNum(p.monto)}?`,
        async () => {
          try {
            await marcarPagadoPlanilla(p.id_planilla);
            this.toast.success('Marcado como pagado.');
            await this.cargar();
          } catch (e) { this.toast.error('Error: ' + e.message); }
        },
        'warning'
      );
    },
    async confirmarEliminar(p) {
      this.mostrarConfirm(
        'Eliminar registro',
        '¿Eliminar este registro de pago? Esta acción no se puede deshacer.',
        async () => {
          try {
            await eliminarPagoPlanilla(p.id_planilla, this.id_usuario);
            this.toast.success('Eliminado.');
            await this.cargar();
          } catch (e) { this.toast.error('Error: ' + e.message); }
        }
      );
    },
    verNota(p) { this.notaActiva = p.notas; this.modalNota = true; },
    metodoCls(m) {
      if (m === 'Efectivo')      return 'metodo-efectivo';
      if (m === 'Transferencia') return 'metodo-transferencia';
      return 'metodo-cheque';
    },
    fmtNum(n) { return Number(n || 0).toLocaleString('es-HN', { minimumFractionDigits: 2 }); },
    fmtFecha(f) { return f ? new Date(f + 'T00:00:00').toLocaleDateString('es-HN') : '—'; },
    parsePeriodo(notas) {
      if (!notas) return '—';
      const idx = notas.indexOf(' - ');
      return idx !== -1 ? notas.substring(idx + 3) : 'Mes Completo';
    }
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");
* { font-family: "Montserrat", sans-serif; box-sizing: border-box; }

.page-container { padding: 16px; width: 100%; overflow-x: hidden; background: #ffffff; min-height: 100vh; color: #212529; }
.page-header { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 16px; margin-bottom: 20px; padding: 0 4px; }
.page-header h1 { font-size: clamp(22px, 4vw, 30px); font-weight: 700; margin: 8px 0; color: #333; }
.subtitle { font-size: 0.875rem; color: #6c757d; margin: 0; }
.header-btns { display: flex; gap: 8px; flex-wrap: wrap; }

.busqueda, .form-input { padding: 8px 12px; font-size: 14px; border-radius: 10px; border: 1px solid #ced4da; outline: none; background: white; color: #212529; transition: all 0.3s ease; }
input:focus, select:focus, textarea:focus { border-color: #c09d62; box-shadow: 0 0 0 3px rgba(192,157,98,0.2); outline: none; }
.form-select, select { padding: 8px 12px; border-radius: 10px; border: 1px solid #ced4da; font-family: "Montserrat", sans-serif; font-size: 14px; cursor: pointer; background: white; color: #212529; }
.form-textarea { width: 100%; padding: 8px 12px; border-radius: 10px; border: 1px solid #ced4da; font-family: "Montserrat", sans-serif; font-size: 14px; resize: vertical; outline: none; background: white; color: #212529; }

.btn-primary   { background-color: #c09d62; color: white; padding: 8px 16px; border: none; border-radius: 10px; font-size: 14px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; transition: all 0.3s ease; font-family: "Montserrat", sans-serif; }
.btn-primary:hover   { background-color: #a38655; transform: scale(1.02); }
.btn-primary:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }
.btn-secondary { background-color: #c09d62; color: white; padding: 8px 16px; border: none; border-radius: 10px; font-size: 14px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; transition: all 0.3s ease; font-family: "Montserrat", sans-serif; }
.btn-secondary:hover { background-color: #a38655; transform: scale(1.02); }
.btn-confirmar { background-color: #198754; color: white; padding: 8px 16px; border: none; border-radius: 10px; font-size: 14px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; transition: all 0.3s ease; font-family: "Montserrat", sans-serif; }
.btn-confirmar:hover { background-color: #146c43; transform: scale(1.02); }
.btn-confirmar:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }
.btn-success { background-color: #198754; color: white; padding: 8px 16px; border: none; border-radius: 10px; font-size: 14px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; transition: all 0.3s ease; font-family: "Montserrat", sans-serif; }
.btn-success:hover { background-color: #146c43; }
.btn-success:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }
.btn-cancel { background-color: #6c757d; color: white; padding: 8px 16px; border: none; border-radius: 10px; font-size: 14px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; transition: all 0.3s ease; font-family: "Montserrat", sans-serif; }
.btn-cancel:hover { background-color: #5a6268; }
.btn-icon { width: 32px; height: 32px; border-radius: 8px; border: 1px solid #dee2e6; background: white !important; color: #495057 !important; cursor: pointer; font-size: 14px; display: inline-flex; align-items: center; justify-content: center; transition: all 0.3s ease; }
.btn-icon:hover { background: #f8f9fa !important; transform: scale(1.05); }
.btn-icon.success { background: #d1e7dd !important; color: #0f5132 !important; border-color: #a3cfbb; }
.btn-icon.success:hover { background: #0f5132 !important; color: white !important; }
.btn-icon.danger { background: #f8d7da !important; color: #842029 !important; border-color: #f1aeb5; }
.btn-icon.danger:hover { background: #842029 !important; color: white !important; }
.btn-icon.info { background: #cff4fc !important; color: #055160 !important; border-color: #9eeaf9; }
.btn-icon.info:hover { background: #055160 !important; color: white !important; }
.btn-close-x { background: none; border: none; cursor: pointer; font-size: 1rem; color: #6c757d; padding: 4px; border-radius: 6px; display: flex; align-items: center; }
.btn-close-x:hover { color: #212529; background: #f8f9fa; }

.loading { display: flex; justify-content: center; padding: 3rem; }
.loading-sm { display: flex; align-items: center; gap: 8px; color: #6c757d; font-size: 0.85rem; padding: 1rem 0; }
.spinner { width: 36px; height: 36px; border: 3px solid #f3f3f3; border-top: 3px solid #c09d62; border-radius: 50%; animation: spin 0.8s linear infinite; }
.spinner-sm { width: 18px; height: 18px; border: 2px solid #e2e8f0; border-top: 2px solid #198754; border-radius: 50%; animation: spin 0.8s linear infinite; display: inline-block; }
@keyframes spin { to { transform: rotate(360deg); } }
.empty-state { display: flex; flex-direction: column; align-items: center; padding: 3rem; gap: 12px; color: #6c757d; text-align: center; }
.empty-state i { font-size: 2.5rem; opacity: 0.4; }

.table-container { width: 100%; overflow-x: auto; -webkit-overflow-scrolling: touch; margin-bottom: 20px; border-radius: 8px; border: 1px solid #e2e8f0; }
.table-container::-webkit-scrollbar { width: 8px; height: 8px; }
.table-container::-webkit-scrollbar-thumb { background: #c09d62; border-radius: 4px; }
.data-table { width: 100%; border-collapse: collapse; font-size: 0.875rem; }
.data-table th { padding: 8px 12px; text-align: left; font-weight: 700; font-size: 0.8rem; border-bottom: 2px solid #dee2e6; background: #f8f9fa; white-space: nowrap; color: #495057; }
.data-table td { padding: 8px 12px; border-bottom: 1px solid #dee2e6; vertical-align: middle; color: #212529; background: white; }
.data-table tbody tr:last-child td { border-bottom: none; }
.data-table tbody tr:hover td { background-color: #f8f9fa; }

.badge-success { background-color: #d1e7dd; color: #0f5132; padding: 3px 8px; font-size: 0.75rem; border-radius: 12px; font-weight: 600; display: inline-block; }
.badge-warning { background-color: #fff3cd; color: #856404; padding: 3px 8px; font-size: 0.75rem; border-radius: 12px; font-weight: 600; display: inline-block; }
.badge-danger  { background-color: #f8d7da; color: #842029; padding: 3px 8px; font-size: 0.75rem; border-radius: 12px; font-weight: 600; display: inline-block; }

.actions { display: flex; gap: 8px; align-items: center; }

.modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 9000; padding: 1rem; }
.modal-box { background: white; border-radius: 12px; box-shadow: 0 8px 32px rgba(0,0,0,0.2); width: 100%; max-width: 560px; max-height: 90vh; display: flex; flex-direction: column; overflow: hidden; }
.modal-sm  { max-width: 400px; }
.modal-xl  { max-width: 780px; }
.modal-header { display: flex; align-items: center; justify-content: space-between; padding: 1rem 1.25rem; border-bottom: 1px solid #dee2e6; background: #f8f9fa; }
.modal-header h2 { font-size: 1rem; font-weight: 700; margin: 0; color: #212529; display: flex; align-items: center; gap: 8px; }
.modal-body { padding: 1.25rem; overflow-y: auto; flex: 1; background: white; }
.modal-footer { padding: 1rem 1.25rem; border-top: 1px solid #dee2e6; display: flex; gap: 8px; justify-content: flex-end; background: #f8f9fa; }

.form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 12px; }
.form-group { display: flex; flex-direction: column; gap: 4px; margin-bottom: 12px; }
.form-group label { font-size: 0.8rem; font-weight: 600; color: #495057; }
.form-group .form-input, .form-group .form-select, .form-group textarea { width: 100%; }
.req { color: #dc3545; margin-left: 2px; }

.filters-row { display: flex; flex-wrap: wrap; align-items: flex-end; gap: 12px; margin-bottom: 16px; background: #f8f9fa; padding: 12px 14px; border-radius: 10px; border: 1px solid #dee2e6; }
.filter-group { display: flex; flex-direction: column; gap: 4px; }
.filter-group label { font-size: 0.78rem; font-weight: 600; color: #495057; }
.totales-box { margin-left: auto; background: #fffaf2; border: 1px solid #e9d8b0; border-radius: 8px; padding: 8px 14px; display: flex !important; flex-direction: column; align-items: flex-end; gap: 2px; }
.totales-box span { font-size: 0.75rem; color: #6c757d; }
.totales-box strong { font-size: 1rem; color: #c09d62; font-weight: 700; }

/* Frecuencia badges */
.badge-frecuencia { display: inline-block; padding: 2px 10px; border-radius: 20px; font-size: 0.7rem; font-weight: 700; margin-left: 8px; vertical-align: middle; }
.badge-frecuencia-mensual   { background: #d1e7dd; color: #0f5132; }
.badge-frecuencia-quincenal { background: #cff4fc; color: #055160; }
.badge-frecuencia-semanal   { background: #fff3cd; color: #856404; }
.frecuencia-info { background: #f0f7ff; border: 1px solid #c8e3ff; border-radius: 8px; padding: 8px 12px; font-size: 0.8rem; color: #055160; margin-bottom: 14px; display: flex; align-items: center; gap: 8px; }
.td-periodo { font-size: 0.8rem; color: #6c757d; white-space: nowrap; }

/* Generar modal */
.gen-config { display: grid; grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)); gap: 12px; margin-bottom: 16px; padding-bottom: 14px; border-bottom: 1px solid #dee2e6; }
.gen-header-row { display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px; }
.gen-label { font-size: 0.8rem; font-weight: 700; color: #495057; }
.gen-total { font-size: 0.9rem; color: #212529; }
.gen-total strong { color: #198754; font-size: 1rem; }
.gen-table { font-size: 0.85rem; }
.gen-table td, .gen-table th { padding: 7px 10px; }
.gen-table input[type="checkbox"] { width: 16px; height: 16px; cursor: pointer; }
.input-salario { padding: 5px 8px; border-radius: 8px; border: 1px solid #ced4da; font-size: 0.85rem; width: 120px; text-align: right; font-family: "Montserrat", sans-serif; background: white; color: #212529; }
.input-salario:focus { border-color: #198754; box-shadow: 0 0 0 2px rgba(25,135,84,0.2); outline: none; }
.input-warn { border-color: #ffc107 !important; }
.row-excluido td { opacity: 0.45; }
.emp-nombre { font-weight: 600; display: block; }
.sin-salario { font-size: 0.72rem; color: #dc3545; display: block; }
.gen-nota { font-size: 0.78rem; color: #6c757d; margin-top: 12px; display: flex; align-items: flex-start; gap: 6px; background: #f0f7ff; border-radius: 8px; padding: 8px 12px; }

.badge-metodo { display: inline-flex; align-items: center; gap: 5px; padding: 3px 10px; border-radius: 12px; font-size: 0.75rem; font-weight: 600; }
.metodo-efectivo      { background: #d1e7dd; color: #0f5132; }
.metodo-transferencia { background: #cff4fc; color: #055160; }
.metodo-cheque        { background: #e2e8f0; color: #495057; }

.modal-sm { max-width: 400px !important; }
.nota-text { font-size: 0.9rem; color: #212529; line-height: 1.6; white-space: pre-wrap; margin: 0; }

@media (max-width: 640px) {
  .form-row, .gen-config { grid-template-columns: 1fr; }
  .page-header, .header-btns { flex-direction: column; align-items: flex-start; }
  .filters-row { flex-direction: column; }
  .totales-box { margin-left: 0; align-items: flex-start; }
}

/* Dark Mode */
.dark .page-container { background: #1e1e1e; color: #e5e5e5; }
.dark .page-header h1 { color: #e5e5e5; }
.dark .subtitle { color: #9e9e9e; }
.dark .form-input, .dark .busqueda { background: #2d2d2d; color: #e5e5e5; border-color: #404040; }
.dark .form-select, .dark select { background: #2d2d2d; color: #e5e5e5; border-color: #404040; }
.dark .form-textarea { background: #2d2d2d; color: #e5e5e5; border-color: #404040; }
.dark .input-salario { background: #2d2d2d; color: #e5e5e5; border-color: #404040; }
.dark .table-container { border-color: #404040; }
.dark .data-table th { background: #2d2d2d; color: #9e9e9e; border-color: #404040; }
.dark .data-table td { background: #1e1e1e; color: #e5e5e5; border-color: #404040; }
.dark .data-table tbody tr:hover td { background: #2d2d2d; }
.dark .btn-icon { background: #2d2d2d !important; color: #9e9e9e !important; border-color: #404040; }
.dark .btn-icon:hover { background: #3d3d3d !important; }
.dark .btn-icon.success { background: #1b4332 !important; color: #6ee7b7 !important; border-color: #065f46; }
.dark .btn-icon.success:hover { background: #065f46 !important; color: white !important; }
.dark .btn-icon.danger { background: #4c1d1d !important; color: #fca5a5 !important; border-color: #7f1d1d; }
.dark .btn-icon.danger:hover { background: #7f1d1d !important; color: white !important; }
.dark .btn-icon.info { background: #0c2d48 !important; color: #7dd3fc !important; border-color: #0369a1; }
.dark .btn-icon.info:hover { background: #0369a1 !important; color: white !important; }
.dark .btn-close-x { color: #9e9e9e; }
.dark .btn-close-x:hover { color: #e5e5e5; background: #3d3d3d; }
.dark .form-group label { color: #9e9e9e; }
.dark .modal-box { background: #1e1e1e; }
.dark .modal-header { background: #2d2d2d; border-color: #404040; }
.dark .modal-header h2 { color: #e5e5e5; }
.dark .modal-body { background: #1e1e1e; }
.dark .modal-footer { background: #2d2d2d; border-color: #404040; }
.dark .empty-state { color: #9e9e9e; }
.dark .filters-row { background: #2d2d2d; border-color: #404040; }
.dark .filter-group label { color: #9e9e9e; }
.dark .totales-box { background: #2a2215; border-color: #4a3d1a; }
.dark .totales-box span { color: #9e9e9e; }
.dark .metodo-cheque { background: #2d2d2d; color: #9e9e9e; }
.dark .nota-text { color: #e5e5e5; }
.dark .gen-config { border-color: #404040; }
.dark .gen-label { color: #9e9e9e; }
.dark .gen-total { color: #e5e5e5; }
.dark .gen-nota { background: #1a2340; color: #9e9e9e; }
.dark .emp-nombre { color: #e5e5e5; }
.dark .row-excluido td { opacity: 0.35; }

/* ── Paginación ── */
.pagination-wrapper { display: flex; justify-content: space-between; align-items: center; padding: 1rem; border-top: 1px solid #dee2e6; }
.pagination-info { color: #6c757d; font-size: 0.875rem; }
.pagination-container { display: flex; gap: 5px; }
.pagination-button { padding: 6px 14px; border: 1px solid #dee2e6; background: white; cursor: pointer; border-radius: 6px; font-size: 0.875rem; font-family: "Montserrat", sans-serif; transition: all 0.3s ease; color: #212529; }
.pagination-button:hover:not(:disabled) { background: #c09d62; color: white; border-color: #c09d62; }
.pagination-button:disabled { opacity: 0.5; cursor: not-allowed; }
.dark .pagination-wrapper { border-color: #404040; }
.dark .pagination-info { color: #9e9e9e; }
.dark .pagination-button { background: #2d2d2d; color: #e5e5e5; border-color: #404040; }
.dark .pagination-button:hover:not(:disabled) { background: #c09d62; color: white; border-color: #c09d62; }
</style>
